import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitPropertyListViewChange = (label: "lista" | "rzuty") => {
    hitGoogleTagManager({event: "view_mode_change", event_label: label});
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitPropertyListViewChange = (label: "lista" | "rzuty") => {
    hitGoogleTagManager({event: "view_mode_change", event_label: label});
};
